import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import HelpLink from '../../packages/kakapo-ui-kit/components/intercom/HelpLink';
import SettingsCollection, { ArchiveRestoreMutationTuple } from '../generic/SettingsCollection';

export default function CycleTemplatesListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.useCycleTemplatesQuery}
			lazyQuery={graphql.useCycleTemplatesLazyQuery}
			field="cycleTemplates"
			translationKey="settings.cycleTemplates"
			title={(cycle: graphql.CycleTemplate) => localize(cycle.title).text}
			subheader={<HelpLink id="help.settings.cycles" />}
			link={(cycle) => `/settings/cycles/${cycle.id}`}
			variables={{}}
			archive={graphql.useArchiveCycleTemplateMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreCycleTemplateMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/cycles/new')}
		/>
	);
}
